<template>
	<ui-card
		icon="fal fa-cogs"
		title="Configurações Gerais"
		text="Faça a configuração do seu clube de pontos."
	>
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<ui-util-box-text-slot title="Ativar o Clube de Pontos." design="mb">
					<ui-switch
						v-model="checked.clubPoints"
						:checked="checked.clubPoints"
						@input="updateClubPoints"
						design="xs"
					/>
				</ui-util-box-text-slot>

				<div v-show="checked.clubPoints">
					<ui-input
						v-model="form.clubName"
						:disabled="!checked.clubPoints"
						placeholder="Clube de Pontos"
						label="Nome do Clube de Pontos:"
						type="text"
					/>

					<ui-input
						v-model="form.clubPointsName"
						:disabled="!checked.clubPoints"
						placeholder="Pontos"
						label="Nome da Pontuação"
						type="text"
					/>

					<div class="grid-50">
						<div>
							<ui-select-2
								v-model="form.clubPointsType"
								:data="clubPointsSelect"
								:disabled="!checked.clubPoints"
								:search="false"
								label="Tipo de Validade:"
								item-label="label"
								return-value="value"
								align="left"
								@input="cleanClubPointsValidate"
							/>
						</div>
						<div class="input-club-points">
							<ui-input
								v-if="form.clubPointsType == 'dinamic'"
								v-model="form.clubPointsValidate"
								:disabled="!checked.clubPoints"
								placeholder="Número de Dias"
								label="Dias:"
								mask="####"
							/>
							<ui-input
								v-if="form.clubPointsType == 'fixed'"
								v-model="form.clubPointsValidate"
								:disabled="!checked.clubPoints"
								placeholder="Data:"
								label="Data Final"
								type="date"
							/>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import moment from 'moment'
	moment.locale('pt-br')

	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSwitch, uiInput, uiSelect2 } from '@/components/ui/form'
	import { uiUtilBoxTextSlot } from '@/components/ui/form/util'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	const clubPointsType = [
		['Validade Dinâmica (em dias)', 'dinamic'],
		['Validade Fixa (data específica)', 'fixed'],
		['Validade Manual (inserir no ato do cadastro)', 'manual'],
	]

	export const defaultOptionsPointsType = (groups) => {
		let list = []
		groups.forEach((item, index) => {
			list.push({
				id: index,
				label: item[0],
				value: item[1],
			})
		})
		return list
	}

	const defaultForm = () => ({
		clubPoints: null,
		clubName: null,
		clubPointsName: null,
		clubPointsType: null,
		clubPointsValidate: null,
	})

	const defaultDisabled = () => ({
		clubPoints: false,
	})

	const defaultChecked = () => ({
		clubPoints: false,
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-club-general',

		components: {
			uiCard,
			uiButton,
			uiInput,
			uiSwitch,
			uiSelect2,
			uiLoadSuccess,
			uiLoadIndicator,
			uiUtilBoxTextSlot,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				loader: { ...defaultLoader() },
				clubPointsSelect: [...defaultOptionsPointsType(clubPointsType)],
				oldForm: {},
			}
		},

		async created() {
			this.loader.body = true

			this.form.clubPoints = await this.getConfig('clubPoints')
			this.checked.clubPoints = this.$mx_checkIsActive(this.form.clubPoints)
			this.form.clubName = await this.getConfig('clubName')
			this.form.clubPointsName = await this.getConfig('clubPointsName')

			const clubPointsValidate = await this.getConfig('clubPointsValidate')
			this.form.clubPointsValidate = this.convertClubPointsValidate(clubPointsValidate)

			this.form.clubPointsType = this.typeOfClubPoints

			this.loader.body = false

			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},

			typeOfClubPoints() {
				const points = this.form.clubPointsValidate
				if (points == 'manual' || !points) return 'manual'
				else if (isNaN(points)) return 'fixed'
				else return 'dinamic'
			},

			verifyClubPointsValidate() {
				if (this.typeOfClubPoints == 'manual') return 'manual'
				else if (this.typeOfClubPoints == 'fixed')
					return moment(this.form.clubPointsValidate, 'YYYY-MM-DD').format('DD/MM/YYYY')
				else return this.form.clubPointsValidate
			},
		},

		methods: {
			getConfig,
			saveConfig,

			updateClubPoints(value) {
				this.form.clubPoints = value ? 'active' : 'inactive'
			},

			convertClubPointsValidate(points) {
				if (points == 'manual' || !points) return points
				else if (isNaN(points)) return moment(points, 'DD-MM-YYYY').format('YYYY-MM-DD')
				else return points
			},

			cleanClubPointsValidate(value) {
				if (Array.isArray(value) || value == 'manual') this.form.clubPointsValidate = null
				else if (value == 'dinamic') this.form.clubPointsValidate = 30
				else this.form.clubPointsValidate = moment().format('YYYY-MM-DD')
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await this.saveConfig('clubPoints', this.form.clubPoints)
					await this.saveConfig('clubName', this.form.clubName)
					await this.saveConfig('clubPointsName', this.form.clubPointsName)
					await this.saveConfig('clubPointsValidate', this.verifyClubPointsValidate)

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
